import abstractModel from '../../core/MercatelyModel';
import { MERCATELY_API } from '../../constants/AppConstants';

const resource = `${MERCATELY_API}/tags`;

const model = abstractModel(resource);

model.getTags = async (params) => model.get(params, { path: resource });

model.delete = async (params) => model.remove(params, { path: resource });

model.getAllTags = async (params) => {
  const newResource = `${resource}/all`;

  return model.get(params, { path: newResource });
};

model.bulkCreate = async (params) => model.save(params, { path: `${resource}/bulk_create` });

export default model;
